export default __webpack_public_path__ + "fonts/sticky-1.svg";